import { render, staticRenderFns } from "./nickName.vue?vue&type=template&id=6dc7e4dd&scoped=true&"
import script from "./nickName.vue?vue&type=script&lang=js&"
export * from "./nickName.vue?vue&type=script&lang=js&"
import style0 from "./nickName.vue?vue&type=style&index=0&id=6dc7e4dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7e4dd",
  null
  
)

export default component.exports